import { render, staticRenderFns } from "./reviews.vue?vue&type=template&id=4fd5d08c&"
import script from "./reviews.vue?vue&type=script&lang=js&"
export * from "./reviews.vue?vue&type=script&lang=js&"
import style0 from "./reviews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fd5d08c')) {
      api.createRecord('4fd5d08c', component.options)
    } else {
      api.reload('4fd5d08c', component.options)
    }
    module.hot.accept("./reviews.vue?vue&type=template&id=4fd5d08c&", function () {
      api.rerender('4fd5d08c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/reviews.vue"
export default component.exports